import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from 'src/api';
import { Account } from 'src/models';
import {
  LoginData,
  LoginResponse,
  CompaniesStatisticsResponse,
} from './auth.types';

export const loginApiPath = '/login';

export const postLogin = (
  data: LoginData,
): Promise<AxiosResponse<LoginResponse & ApiError>> => {
  return instance
    .post<LoginResponse>(loginApiPath, data)
    .catch((e) => e.response as AxiosError<ApiError> as never);
};

export const accountApiPath = '/account';

export const fetchUserProfile = (): Promise<
  AxiosResponse<Account & ApiError>
> => {
  return instance
    .get<Account>(accountApiPath)
    .catch((e) => e.response as AxiosError<ApiError> as never);
};

export const companiesStatisticsApiPath = '/companies/statistics';

export const fetchCompaniesStatisticsApi = (): Promise<
  AxiosResponse<CompaniesStatisticsResponse & ApiError>
> => {
  return instance
    .get<CompaniesStatisticsResponse>(companiesStatisticsApiPath)
    .catch((e) => e.response as AxiosError<ApiError> as never);
};

export const logoutApiPath = '/logout';

export const postLogout = (): Promise<
  AxiosResponse<LoginResponse & ApiError>
> => {
  return instance
    .post<LoginResponse>(logoutApiPath)
    .catch((e) => e.response as AxiosError<ApiError> as never);
};

export const recoveryPasswordApiPath = '/account/recovery-password';

export const recoveryPasswordAPI = ({
  data,
}: {
  data: { email: string };
}): Promise<AxiosResponse<{ token: string } & ApiError>> => {
  return instance
    .post(recoveryPasswordApiPath, data)
    .catch((e) => e.response as AxiosError<ApiError> as never);
};

export const resetPasswordApiPath = '/account/reset-password';

export const resetPasswordAPI = ({
  data,
}: {
  data: {
    token: string;
    password: string;
  };
}): Promise<AxiosResponse<void & ApiError>> => {
  return instance
    .post(resetPasswordApiPath, data)
    .catch((e) => e.response as AxiosError<ApiError> as never);
};
